import { registerDecorator, ValidationArguments } from 'class-validator'

/** Validates that the decorated property is null/undefined whenever the named sibling property is truthy. */
export function IsEmptyWhenProperty(property: string) {
  return (object: object, propertyName: string) => {
    registerDecorator({
      name: 'IsEmptyWhenProperty',
      target: object.constructor,
      propertyName,
      constraints: [property],
      validator: {
        validate,
        defaultMessage,
      },
    })
  }
}

function validate(value: unknown, args: ValidationArguments): boolean {
  const [property] = args.constraints
  if (!(args.object as Record<string, unknown>)[property]) {
    return true
  }
  return value === null || value === undefined
}

function defaultMessage(args?: ValidationArguments): string {
  return `${args?.property} must not be set when ${args?.constraints.join(', ')} is set`
}
